







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class EventAddFormIframe extends Vue {
  private get pageType() {
    return this.$route.name === 'EventCopy' ? 'copy' : this.$route.query.eventNo ? 'edit' : 'add';
  }

  private get pageTitle() {
    switch (this.pageType) {
      case 'add':
        return '등록'
      case 'edit':
        return '수정'
      case 'copy':
        return '복사'
      default:
        return '등록';
    }
  }

  private get remoteSrc() {
    const url = `/promotion/event/${this.pageType}?`
    const queryObject = { serviceType: 'PREMIUM', ...this.$route.query };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + url + queryString;
  }
}
